<template>
    <div class="intro-page">
        <div class="page-header">中医助理智能机器人介绍</div>
        <div class="tizhi-page">
            <p class="page-text">中医助理智能机器人，由中国中医科学院中医药信息研究所大健康智能研发中心与台湾黄耆医疗联盟合作，在十多年中医药算法、医案挖掘分析、名医经验传承以及中医药词网研究基础上，面向医院、社区、基层诊所、家庭，通过对数以百万计的医学图像、医学期刊、图书及论文数据、诊断病历等数据，进行自然语言处理，并模拟医生的临床诊断过程和治疗方法，得出治疗方案的智能机器人。</p>
            <p class="page-text">中医智能诊断机器人通过将中医临床指南、专家经验等知识结合，构建起神经知识网络的数据知识模型，通过对医生临床情景的识别和模拟，将临床思维人工智能化，并通过机器学习中的大量算法实现系统自主决策能力，构建起的智能专家决策系统，采用人工智能技术中的多种机器学习、深度学习算法和大数据技术对古今医案、临床指南、名医经验、养生方法、适宜技术等文本数据进行知识图谱建设，实现对中医临床诊疗的决策支持。</p>
            <p class="page-text">中医助理智能机器人，配合中医智能云后台系统，为用户提供症状采集、智能问诊、处方推荐等功能，方便患者能够及时问诊，快速定位症状提高问诊效率，方便广大患者。</p>
        </div>
        <div class="page-info">
            <el-carousel class="customize-list" indicator-position="outside" :interval="5000" type="card" height="320px">
                <el-carousel-item  class="list" v-for="(item,index) in customizeList" :key="index">
                    <div class="list-pic">
                        <img :class="item.type&&item.type=='height'?'img-height':'img-width'" :src="item.pic" alt="">
                    </div>
                </el-carousel-item>
            </el-carousel> 
            <div class="page-info"> 
            <ul>
                <li class="info-list">
                    <p class="list-tit"><span class="icon"></span>1.接待功能</p>
                    <el-row :gutter="20" class="list-txt">
                        <el-col :span="20">
                            <p class="section-text">1.1迎接患者。中医助理智能机器人发现患者进入医院大厅，主动迎接，并播报“欢迎您来到**医院，有什么可以帮助您？”的欢迎用语，并根据不同场景和时间段进行问候。</p>
                            <p  class="section-text">1.2引领患者。中医助理智能机器人根据GPS导航功能，带领患者到达某一科室。</p> 
                        </el-col>
                        <el-col :span="4"> 
                            <img src="../../assets/images/img1.jpg" alt=""> 
                        </el-col>
                    </el-row>
                </li>
                <li class="info-list">
                    <p class="list-tit"><span class="icon"></span>2.介绍功能</p>
                    <el-row :gutter="20" class="list-txt">
                        <el-col :span="20">
                            <p class="section-text">中医助理智能机器人对患者提出关键问题对患者进行功能指引，问询患者是否需要介绍医院、诊疗特色、养生知识、自动问诊等。</p> 
                        </el-col>
                        <el-col :span="4"> 
                            <img src="../../assets/images/img2.jpg" alt=""> 
                        </el-col>
                    </el-row>
                </li>
                <li class="info-list">
                    <p class="list-tit"><span class="icon"></span>3.会员管理功能</p>
                    <el-row :gutter="20" class="list-txt">
                        <el-col :span="16">
                            <p class="section-text">中医助理智能机器人提供患者会员功能——为了收集患者信息，中医助理智能机器人系统能够让机器人通过人脸进行识别，机器人提供会员ID。</p> 
                            <p class="section-text">3.1会员识别。会员患者站在机器人前面，机器人通过人脸识别主动问候——“**先生（女士），有什么可以帮助您？”</p> 
                            <p class="section-text">3.2会员注册。人脸注册，补充个人资料——姓名、出生日期、性别、手机号码。</p> 
                            <p class="section-text">3.3会员登录。提供手机号码登陆、人脸识别登陆、二维码扫描登陆三种方式。用户必须登录后才可以使用智能医疗相关内容。</p> 
                        </el-col>
                        <el-col :span="4"> 
                            <img src="../../assets/images/img3.jpg" alt=""> 
                        </el-col>
                        <el-col :span="4"> 
                            <img src="../../assets/images/img4.jpg" alt=""> 
                        </el-col>
                    </el-row>
                </li> 
                <li class="info-list">
                    <p class="list-tit"><span class="icon"></span>4.中医助理智能机器人病例采集</p>
                    <el-row :gutter="20" class="list-txt">
                        <el-col :span="14">
                            <p class="section-text">4.1症状语音识别，机器人系统提示用户语音输入自己的症状，识别完毕后，提交到中医云平台并返回结果。</p>  
                            <p class="section-text">4.2症状图像识别，机器人除了收集用户的症状意外，还可通过图像收集舌相和面相。</p>
                            <p class="section-text">4.3症状诊断确认，系统进入“中医诊断区域”和“中医证候区域”，患者确认信息。</p>
                            <p class="section-text">4.4症状决策，中医机器人系统收集完用户的全部症状和信息后，进入决策流程，所有收集的信息统一提交到智能中医云平台进行运算，并返回结果：处方推荐、名医经验、中成药推荐、养生保健、适宜技术。</p>
                        </el-col>
                        <el-col :span="10" class="gather "> 
                            <el-carousel indicator-position="outside"  type="card" :interval="5000" height="360px">
                                <el-carousel-item   class="list" v-for="(item,index) in gatherList" :key="index">
                                    <div class="list-pic">
                                        <img class=" img-width img-width" :src="item.pic" alt="">
                                    </div>
                                </el-carousel-item>
                            </el-carousel> 
                        </el-col> 
                         <!-- <el-col :span="6"> 
                            <img src="../../assets/images/img5-1.jpg" alt=""> 
                        </el-col>  -->
                    </el-row>
                </li> 
                <li class="info-list">
                    <p class="list-tit"><span class="icon"></span>5.社区养老</p>
                     <div class="list-txt"> 
                        <p class="section-text">中国老龄化问题逐渐严重，社区养老机器人解决方案应运而生。</p>
                        <p class="section-text">5.1AloT服务模式。通过蓝牙及Wifi协议，中医助理智能机器人与智能检测模组设备进行联通，通过为患者检测结果，分析各项身体关键指标情况，作为用户健康服务依据。</p>
                        <p class="section-text">5.2AI+搭建智慧社区健康平台。机器人终端分析健康信息，进行日常健康处理，有效缓解医疗资源、提供医生资源。</p>
                        <p class="section-text">5.3构建智慧社区用户健康中心，机器人提供日常体检、医疗咨询、健康建议、社区服务、政策须知、无人办理功能，提供健康+智能服务。</p>
                     </div>
                </li> 
                <li class="info-list">
                    <p class="list-tit"><span class="icon"></span>6.中医助理智能机器人系统优势</p>
                     <div class="list-txt"> 
                        <p class="section-text">6.1更智能的适老化体验。页面清晰简洁，多采用语音的方式，减少点击交互次数，便捷患者使用，保证用户良好的体验感。</p>
                        <p class="section-text">6.2全面且个性化的服务需求，通过信息采集、人脸识别等方式使服务更能满足患者需求。</p>
                        <p class="section-text">6.3体现中医特色，中医理念。</p>  
                     </div>
                </li> 
            </ul>
        </div>
        </div> 
        <introFooter>
            <div slot="content" >
                <p>联系人：李国祥博士</p> 
            </div>
        </introFooter>
    </div>
</template>

<script>
import introFooter from './intro_footer.vue'
export default {
    components: {
        introFooter,
    },
    data () {
        return {
            customizeList:[
                {
                    pic:require('../../assets/images/jqr1.jpg'), 
                    type:'height',
                },
                {
                    pic:require('../../assets/images/jqr2.jpg'), 
                    type:'width',
                },
                {
                    pic:require('../../assets/images/jqr3.jpg'), 
                    type:'width',
                }, 
            ],
            gatherList:[
                {
                    pic:require('../../assets/images/img5.jpg'), 
                    type:'height',
                },
                {
                    pic:require('../../assets/images/img5-1.jpg'), 
                    type:'height',
                },
                {
                    pic:require('../../assets/images/img5-2.jpg'), 
                    type:'width',
                },
                {
                    pic:require('../../assets/images/img5-3.jpg'), 
                    type:'width',
                },
                {
                    pic:require('../../assets/images/img5-4.jpg'), 
                    type:'height',
                },
                {
                    pic:require('../../assets/images/img5-5.jpg'), 
                    type:'width',
                },
                {
                    pic:require('../../assets/images/img5-6.jpg'), 
                    type:'width',
                },

                {
                    pic:require('../../assets/images/img5-7.jpg'), 
                    type:'width',
                },
                {
                    pic:require('../../assets/images/img5-8.jpg'), 
                    type:'width',
                },
            ]
        }
    }
}
</script>


<style lang="less"> 
    @import url('../../css/intro_page.less');  
    /* 走马灯每个item */
    
</style> 